import { mapState } from 'vuex'

export default {
  components: {
  },
  name: 'HtContactItem',
  props: {
    c: Array,
    data: String,
    items: Array,
    title: String,
    searchType: Number
  },
  data() {
    return {
      model_: {},
    }
  },
  created () {},
  mounted() {},
  methods: {
    emitClick() {
      this.$emit('ListenChild', this.model_)
    },
    details(item) {
      this.$store.commit('ht/interfacePlat', Object.assign({}, this.interfacePlat, {
        interfacePlatId: item.facilitator,
      }))

      this.$store.commit('ht/orderDetails', item)

      /**
       * 国内酒店
       */
      this.model._international == 0 && this.$router.push({
        path: '/ht/htQuery/htDetails',
        query: {
          jdid: item.jdid,
          staticData: item.staticData,
          ccsqdId: this.$route.query.ccsqdId,
          routeId: this.$route.query.routeId,
          i:this.$route.query.i,
          protocol: item.protocol,
          hotelInterfaceBeans: JSON.stringify(item.hotelInterfaceBeans)
        }
      })
      /**
       * 国际酒店
       */
      this.model._international == 1 && this.$router.push({path: '/ht/htQuery/htDetailsInt', query: {jdid: item.platHotelId}})
    },
  },
  computed: mapState({
    interfacePlat: function (state) {
      return state.ht.interfacePlat
    },
    model: (state) => state.ht.htSearchInfo,
  }),
}